/**
 * Proyecto: MOGOTAX-SERVER
 * Autor: Megatrack GPS SAS
 * Fecha de creación: 11 de noviembre 2024
 * Licencia: Propiedad Privada
 *
 * Este código es propiedad exclusiva de Megatrack GPS SAS & Mogotax SAS y no puede ser distribuido, copiado, modificado, publicado, sublicenciado ni comercializado sin el consentimiento expreso y por escrito de ambas empresa.
 *
 * Copyright (c) 2025 Megatrack GPS SAS. Todos los derechos reservados.
 */
import React from "react";
import PropTypes from "prop-types";
import { List } from "antd";
import { Box } from "@mui/material";
import TrasladoItem from "./TrasladoItem";

const TrasladoList = ({ traslados, loading, onSelect, getStatusColor }) => {
  return (
    <List
      loading={loading}
      dataSource={traslados}
      renderItem={(traslado) => {
        const statusColor = getStatusColor(traslado.status);
        return (
          <List.Item
            key={traslado.id}
            style={{
              padding: 0,
            }}
          >
            <Box sx={{ px: 2, width: '100%' }}>
              <TrasladoItem
                traslado={traslado}
                onSelect={onSelect}
                statusColor={statusColor}
              />
            </Box>
          </List.Item>
        );
      }}
    />
  );
};

TrasladoList.propTypes = {
  traslados: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      status: PropTypes.string.isRequired,
      fecha: PropTypes.string.isRequired,
      hora_recogida: PropTypes.string.isRequired,
      origen_direccion: PropTypes.string.isRequired,
      origen_ciudad: PropTypes.string.isRequired,
      destino_direccion: PropTypes.string.isRequired,
      destino_ciudad: PropTypes.string.isRequired,
      nombre_paciente: PropTypes.string.isRequired,
      inicio_status: PropTypes.string,
      fin_status: PropTypes.string,
    }).isRequired
  ).isRequired,
  loading: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  getStatusColor: PropTypes.func.isRequired,
};

export default TrasladoList;
